module.exports = __webpack_public_path__ + "static/img/slmPurpose2.a46c19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slmPurpose2.png
// module id = hd1x
// module chunks = 2